import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth.service';

export const requiresDowngradePickerGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.requiresDowngradePicker()
    ? true
    : router.createUrlTree(['/dashboard']);
};
